// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"sp-z","badgeLink":"tp-z","category":"up-z"};